import { fetchOrLogout } from "../../../utils/helpers";
import { getBaseUrl } from "../../../utils/requestUtils";

type RequisitionAlertType = "cfc_eligibility" | "redraw";

const DismissRequisitionAlert = async (
  token: string,
  reqIdentifier: string,
  alertType: RequisitionAlertType,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  const response = await fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/requisition_alert_dismissal`,
    {
      method: "POST",
      body: JSON.stringify({
        req_identifier: reqIdentifier,
        alert_type: alertType,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );

  return response;
};

export const DismissCfcAlert = async (
  token: string,
  reqIdentifier: string,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> =>
  DismissRequisitionAlert(
    token,
    reqIdentifier,
    "cfc_eligibility",
    setLoggedOut,
  );

export const DismissRedrawAlert = async (
  token: string,
  reqIdentifier: string,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> =>
  DismissRequisitionAlert(token, reqIdentifier, "redraw", setLoggedOut);
